import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React from 'react';

import RenderBlocks from 'components/cms-blocks/render-blocks';
import { TSanityBlock } from 'components/cms-blocks/render-blocks/types';
import { BreadcrumbStructuredData } from 'components/common/breadcrumbs/structured-data';
import Main from 'components/common/main';
import getMetaTags from 'components/common/meta-tags';
import { ICustomMetaTagsSanity } from 'components/common/meta-tags/types';
import { filterDataToSingleItem } from 'framework/sanity/filter-data-to-single-item';
import { mapBlocks } from 'framework/sanity/map-blocks';
import { articlesLandingQuery } from 'framework/sanity/queries/articles-landing';
import { getClient } from 'framework/sanity/sanity-client';
import { setCacheControlOneHour } from 'utils/cache';

import * as St from './styles';

interface IProps {
  data: {
    page: {
      blocks: TSanityBlock[];
      meta?: ICustomMetaTagsSanity;
    };
  };
}

export default function ArticlesLandingPage({ data: { page } }: IProps) {
  return (
    <>
      <Head>{getMetaTags({ meta: page.meta })}</Head>
      <BreadcrumbStructuredData
        crumbs={[
          {
            label: 'Learning Hub',
          },
        ]}
      />
      <Main light>
        <St.BlocksWrapper>
          <RenderBlocks blocks={page.blocks || []} />
        </St.BlocksWrapper>
      </Main>
    </>
  );
}

interface IArticlesLandingQuery {
  _id: string;
  blocks: TSanityBlock[];
}

export const getServerSideProps: GetServerSideProps = async ({
  preview = false,
  res,
}) => {
  setCacheControlOneHour(res);

  const data = await getClient().fetch<IArticlesLandingQuery[]>(
    articlesLandingQuery,
  );

  const page = filterDataToSingleItem(data);

  if (!page) {
    return {
      notFound: true,
    };
  }

  const blocks = await mapBlocks(page.blocks);

  return {
    props: {
      preview,
      data: {
        page: {
          ...page,
          blocks,
        },
      },
    },
  };
};
